import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import LandingPage       from "./Pages/LandingPage";
import AuthPage          from "./Pages/AuthPage";
import PricingPage       from "./Pages/PricingPage";
import Dashboard         from "./Pages/Dashboard";
import SettingsPage      from "./Pages/SettingsPage";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import ResetPasswordPage  from "./Pages/ResetPasswordPage";
import PaymentSuccessPage from "./Pages/PaymentSuccessPage";
import AboutPage    from "./Pages/AboutPage";
import ContactPage  from "./Pages/ContactPage";
import FAQPage      from "./Pages/FAQPage";
import PrivacyPage  from "./Pages/PrivacyPage";
import TermsPage    from "./Pages/TermsPage";
import "./App.css";

function PrivateRoute({ children }) {
  const { user, isSubscribed } = useAuth();
  if (!user)         return <Navigate to="/" replace />;
  if (!isSubscribed) return <Navigate to="/pricing" replace />;
  return children;
}

function AuthRoute({ children }) {
  const { user, isSubscribed } = useAuth();
  if (user && isSubscribed)  return <Navigate to="/dashboard" replace />;
  if (user && !isSubscribed) return <Navigate to="/pricing" replace />;
  return children;
}

function PricingRoute({ children }) {
  const { user, isSubscribed } = useAuth();
  if (!user)        return <Navigate to="/auth" replace />;
  if (isSubscribed) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"                element={<LandingPage />} />
        <Route path="/auth"            element={<AuthRoute><AuthPage /></AuthRoute>} />
        <Route path="/pricing"         element={<PricingRoute><PricingPage /></PricingRoute>} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password"  element={<ResetPasswordPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/about"           element={<AboutPage />} />
        <Route path="/contact"         element={<ContactPage />} />
        <Route path="/faq"             element={<FAQPage />} />
        <Route path="/privacy"         element={<PrivacyPage />} />
        <Route path="/terms"           element={<TermsPage />} />
        <Route path="/dashboard"       element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/settings"        element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
        <Route path="*"                element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
